// removed by extract-text-webpack-plugin
module.exports = {"List":"htOHyjgTKAg2_qCJdh4hf","Header":"_2dKSKYRnlj13ZQ5klh66QC","green":"_2xfvWdR5v_MmYw1kbi8p63","red":"M0sMlv09LPkC4JRRNZlZb","Row":"_2S10dzntGhHlCs2bUqALjl"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/AdminsList/index.css
// module id = 966
// module chunks = 0